export default function About() {
  return (
    <section id="hakkimda" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/13efc658f5e4badd7f709164859f9a94/dde3e69b73bff22d07fc2ee6a516692b.jpeg"
                alt="Tolga AYDOS - Fen Bilimleri Öğretmeni"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/20 to-transparent"></div>
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-2xl p-6 border-4 border-teal-500">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl">
                  <i className="ri-trophy-line text-3xl text-white"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    20+
                  </div>
                  <div className="text-sm text-gray-600" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Yıllık Deneyim
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-8 lg:pt-0">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 rounded-full border border-teal-200">
              <div className="w-2 h-2 bg-teal-500 rounded-full"></div>
              <span className="text-teal-700 text-sm font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
                LGS Odaklı Fen Bilimleri Öğretmeni - Tekirdağ
              </span>
            </div>

            {/* H1 Heading */}
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Tolga Aydos | Tekirdağ LGS Odaklı
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600"> Fen Bilimleri Öğretmeni</span>
              </h1>
            </div>

            {/* Hakkımda Section */}
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Hakkımda
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Merhaba, ben <strong>Tolga Aydos</strong>. Tekirdağ'da Fen Bilimleri Öğretmeni ve Eğitim Teknolojileri Uzmanıyım. 
                20 yılı aşkın eğitim deneyimimle öğrencilerimin fen bilimlerini yalnızca ezberlemesini değil; 
                <strong> anlamasını, sorgulamasını ve öğrenmekten keyif almasını</strong> hedefliyorum. 
                Özellikle <strong>LGS hazırlık sürecinde</strong> yüzlerce öğrencinin akademik gelişimine rehberlik ettim.
              </p>
            </div>

            {/* LGS Odaklı Yaklaşım */}
            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                LGS Odaklı ve Kişiye Özel Öğrenme Yaklaşımı
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Her öğrencinin öğrenme hızı ve ihtiyacının farklı olduğuna inanıyorum. 
                Bu nedenle derslerimde <strong>kişiye özel öğrenme planları</strong>, konu bazlı analizler 
                ve <strong>dijital destekli öğretim yöntemleri</strong> kullanıyorum. 
                Amacım, öğrencinin eksiklerini doğru tespit ederek en verimli şekilde ilerlemesini sağlamaktır.
              </p>
            </div>

            {/* Yapay Zeka Destekli Sistem */}
            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Yapay Zekâ Destekli Öğrenme Sistemi
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Öğrencilerimin gelişimini daha yakından takip edebilmek için 
                <strong> yapay zekâ destekli öğrenme sistemlerinden</strong> yararlanıyorum. 
                Bu sistemler sayesinde öğrencinin yaptığı çalışmalar analiz edilir, 
                zorlandığı konular net biçimde belirlenir ve buna uygun 
                <strong> kişiselleştirilmiş çalışma planları</strong> oluşturulur. 
                Böylece gereksiz tekrarlar yerine, ihtiyaca odaklanan 
                <strong> etkili ve kalıcı bir öğrenme süreci</strong> sağlanır. 
                Veliler de bu süreci daha <strong>şeffaf ve düzenli</strong> şekilde takip edebilir.
              </p>
            </div>

            {/* Dijital Platform */}
            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Dijital Eğitim Platformu: tolgaaydos.com
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <strong>tolgaaydos.com</strong>'u; öğrencilerimin ve velilerin 7/24 erişebileceği, 
                sadece ders notlarının değil aynı zamanda bireysel gelişim takibinin, 
                düzenli geri bildirimlerin ve rehberlik süreçlerinin yer aldığı 
                <strong> kapsamlı bir eğitim platformu</strong> olarak tasarladım.
              </p>
            </div>

            {/* Hedef */}
            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Eğitimde Hedefim
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Hedefim; öğrencilerimin sınav başarısının yanında 
                <strong> özgüvenli, düşünen ve problem çözebilen bireyler</strong> 
                olarak gelişmelerine katkı sağlamaktır.
              </p>
            </div>

            {/* CTA */}
            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="#ders-notlari"
                className="px-8 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-full font-semibold hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                Ders Notlarına Göz At
              </a>
              <a
                href="#online-deneme"
                className="px-8 py-4 bg-white text-teal-600 rounded-full font-semibold border-2 border-teal-500 hover:bg-teal-50 hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                Deneme Sınavlarını İncele
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20">
          {[
            { icon: 'ri-user-star-line', value: '200+', label: 'Başarılı Öğrenci', color: 'from-teal-500 to-emerald-500' },
            { icon: 'ri-medal-line', value: '%95', label: 'Başarı Oranı', color: 'from-blue-500 to-cyan-500' },
            { icon: 'ri-book-open-line', value: '500+', label: 'Ders Materyali', color: 'from-purple-500 to-pink-500' },
            { icon: 'ri-time-line', value: '20+', label: 'Yıllık Tecrübe', color: 'from-orange-500 to-red-500' },
          ].map((stat, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border border-gray-200 hover:shadow-xl hover:scale-105 transition-all duration-300 text-center"
            >
              <div className={`w-14 h-14 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br ${stat.color} rounded-xl`}>
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                {stat.value}
              </div>
              <div className="text-sm text-gray-600" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}